import styled from "styled-components";
import frontImage from "../../img/login-background-retos.webp";
import { colors } from "../../theme/colors";
import Divider from "@mui/material/Divider";

export const FullScreenWrapper = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
`;

export const LeftSection = styled.div`
  width: 100%;
  min-height: 100vh;
  background-image: url(${frontImage});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  border-radius: 0px 0px 56px 0px;
  justify-content: center;
  align-items: flex-start;
  padding: 2rem;

  @media (max-width: 768px) {
    min-height: 400px;
    border-radius: 0px;
  }
`;

export const RightSection = styled.div`
  width: 100%;
  min-height: 100vh;
  background-color: ${colors.white.main};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2rem;

  @media (max-width: 768px) {
    min-height: 400px;
    padding: 4rem 0rem;
  }
`;

export const GridContainerWrapper = styled.div`
  display: flex;
  min-height: 100vh;

  .MuiGrid-container {
    flex: 1;
  }
`;

/* Componente de pasos */
export const StepsContainer = styled.div`
  background-color: ${colors.white.main};
  border-radius: 80px 0px 80px 0px;
  padding: 3rem 2.5rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  max-width: 450px;
  width: 100%;
  backdrop-filter: blur(10px);

  @media (max-width: 768px) {
    padding: 2rem 1.5rem;
    max-width: 99%;
  }
`;

export const StepItem = styled.div`
  display: flex;
  align-items: flex-start;
  position: relative;
  margin-bottom: 3rem;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const StepCircle = styled.div`
  margin-top: 2.5rem;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: ${colors.secondary};
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 1rem;
  flex-shrink: 0;
  margin-right: 1.5rem;
  position: relative;
  z-index: 2;

  @media (max-width: 768px) {
    width: 40px;
    height: 40px;
    font-size: 1rem;
    margin-right: 1rem;
  }
`;

export const StepContent = styled.div`
  flex: 1;
  padding-top: 0.25rem;
`;

export const StepTitle = styled.h3`
  color: ${colors.primary};
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0 0 0.5rem 0;
  line-height: 1.2;

  @media (max-width: 768px) {
    font-size: 1.3rem;
  }
`;

export const StepDescription = styled.p`
  color: ${colors.gray.textLight};
  font-size: 1rem;
  line-height: 1.5;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 0.9rem;
  }
`;

export const StepLine = styled.div`
  position: absolute;
  left: 18px;
  top: 70px;
  width: 6px;
  height: 305%;
  background: #e5ebf0;
  border-radius: 2px;
  z-index: 1;

  @media (max-width: 768px) {
    left: 19px;
    top: 3rem;
    height: calc(405% - 40px);
    width: 3px;
  }
`;

export const Wrapper = styled.div`
  position: absolute;
  width: 100%;
  min-height: 100%;
  top: 0;
  left: 0;
  display: flex;
  background-image: url(${frontImage});
  background-size: cover;
  overflow: scroll;
`;

export const HomeSectionWrapper = styled.div`
  background-color: ${colors.white.main};
  min-height: 250px;
  width: 50%;
  border-radius: 48px 0;
  top: 50%;
  left: 40%;
  padding: 2rem 0.5rem 1rem 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 1062px;
  position: absolute;
  transform: translateY(-50%);

  @media (max-width: 768px) {
    width: 100%;
    position: initial;
    border-radius: 0;
    height: 100vh;
    transform: none;
  }
`;

export const FormSectionWrapper = styled.div`
  background-color: ${colors.white.main};
  min-height: 100%;
  width: 45%;
  border-radius: 10% 0 0 10%;
  position: relative;
  top: 0%;
  left: 55%;
  display: flex;
  align-items: center;
  padding: 3rem 1rem;

  @media (max-width: 768px) {
    width: 100%;
    position: initial;
    border-radius: 0;
  }
`;

export const FromWrapper = styled.div`
  width: 100%;
  text-align: center;
`;

export const StyledDivider = styled(Divider)`
  width: ${(props) => props.width};
  margin: 1.5rem 0 !important;
`;
